export default "__VITE_ASSET__68175fec__"